const initialState = {
  threads: [],
  begun: false
};

const reducer = (state, action) => {
  if (typeof state === 'undefined' ) {
    return initialState;
  }

  switch (action.type) {
    case 'BEGIN_GAME':
      return {
        ...state,
        begun: true
      }

    case 'ADD_MESSAGE':
      var threads = [...state.threads ];

      // New Thread
      if (threads.filter((t) => (t.threadName === action.threadName)).length === 0) {
        return {
          ...state,
          threads: threads.concat({
            threadName: action.threadName,
            hasUnread: true,
            messages: [{
              from: action.from,
              text: action.text,
              next: action.next,
              seen: false
            }],
            options: []
          })
        }
      } else  { // Existing thread
        return {
          ...state,
          threads: threads.map((t) => {
            if (t.threadName === action.threadName) {

              // Check if the message is already in the thread by checking
              // the `next` property of the messages.
              // Don't add it if it is already there.
              if(t.messages.filter(m => m.next === action.next).length > 0) {
                return t;
              }

              return {
                threadName: t.threadName,
                hasUnread: true,
                messages: t.messages.concat({
                  from: action.from,
                  text: action.text,
                  next: action.next,
                  seen: false
                }),
                options: []
              }
            }
            return t;
          })
        };
      }

    case 'MARK_SEEN':
      return {
        ...state,
        threads: state.threads.map((t) => {
          if (t.threadName !== action.threadName ) {
            return t;
          }

          return {
            ...t,
            messages: t.messages.map((m) => {
              if (m.next === action.next ) {
                return {
                  ...m,
                  seen: true
                }
              } else {
                return m;
              }
            })
          }
        })
      }

    case 'MARK_READ':
      return {
        ...state,
        threads: state.threads.map((t) => {
          if (t.threadName !== action.threadName ) {
            return t;
          }

          return {
            ...t,
            hasUnread: false
          }
        })
      }

    case 'ADD_CHOICE':
      return {
        ...state,
        threads: state.threads.map((t) => {
          if (t.threadName !== action.threadName ) {
            return t;
          }

          return {
            ...t,
            options: action.options
          }
        })
      }

    case 'REMOVE_CHOICE':
      return {
        ...state,
        threads: state.threads.map((t) => {
          if (t.threadName !== action.threadName ) {
            return t;
          }

          return {
            ...t,
            options: []
          }
        })
      }

    default:
      return state
  }
}

export default reducer;
